import { SVGProps } from 'react';

export const TextAlignCenterIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="12"
      viewBox="0 0 14 12"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M0 0.55C0 0.246243 0.25128 0 0.56125 0H12.9087C13.2187 0 13.47 0.246243 13.47 0.55C13.47 0.853757 13.2187 1.1 12.9087 1.1H0.56125C0.25128 1.1 0 0.853757 0 0.55Z"
        fill="#474747"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M2.46 4C2.46 3.69624 2.68651 3.45 2.96592 3.45H10.5041C10.7835 3.45 11.01 3.69624 11.01 4C11.01 4.30376 10.7835 4.55 10.5041 4.55H2.96592C2.68651 4.55 2.46 4.30376 2.46 4Z"
        fill="#474747"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M0 7.45C0 7.14624 0.235944 6.9 0.526995 6.9H12.943C13.2341 6.9 13.47 7.14624 13.47 7.45C13.47 7.75376 13.2341 8 12.943 8H0.526995C0.235944 8 0 7.75376 0 7.45Z"
        fill="#474747"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M2.535 10.9C2.535 10.5962 2.75753 10.35 3.03204 10.35H10.438C10.7125 10.35 10.935 10.5962 10.935 10.9C10.935 11.2038 10.7125 11.45 10.438 11.45H3.03204C2.75753 11.45 2.535 11.2038 2.535 10.9Z"
        fill="#474747"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default TextAlignCenterIcon;
